import React from "react";
import PropTypes from "prop-types";
import { reduxForm, Field } from "redux-form";
import TextInput from "TextInput";
import ModalForm from "ModalForm";
import Checkbox from "Checkbox";

const AddTypeModal = props => (
  <ModalForm
    data-testid="type-modal-container"
    title={props.title}
    isVisible={props.show}
    onClose={props.toggleModal}
    onSubmit={e => {
      e.preventDefault();
      props.onSubmit();
    }}
    onFormSubmit={e => {
      e.preventDefault();
      props.onSubmit();
    }}
    buttonDisabled={props.disabled}
    hiddenButtonDisabled={props.disabled}
  >
    <Field name="name" label="Name" component={TextInput} />
    <Field name="code" label="Code" component={TextInput} />
    <Field name="isForCe" label="Is for CE" component={Checkbox} />
    <Field name="isForDe" label="Is for DE" component={Checkbox} />
    <Field name="isForIe" label="Is for IE" component={Checkbox} />
    <Field name="isCeDeprecated" label="CE Deprecated" component={Checkbox} />
    <Field name="isDeDeprecated" label="DE Deprecated" component={Checkbox} />
    <Field name="isIeDeprecated" label="IE Deprecated" component={Checkbox} />
  </ModalForm>
);

AddTypeModal.propTypes = {
  title: PropTypes.string.isRequired,
  show: PropTypes.bool,
  toggleModal: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.shape({ id: PropTypes.any }), // eslint-disable-line
  disabled: PropTypes.bool
};

AddTypeModal.defaultProps = {
  show: false,
  initialValues: {},
  disabled: false
};

export default reduxForm({
  form: "types",
  enableReinitialize: true
})(AddTypeModal);
